import { Check, RotateCw, UserRound, X } from "lucide-react";

const Phone = ({ wide, ok }) => (
  <div className="flex flex-col items-center gap-3">
    <div className={`relative flex items-center justify-center rounded-[18px] border-[5px] border-[#2C1E16] bg-[#F4EAD5] ${wide ? "h-24 w-40" : "h-40 w-24"}`}>
      <span className={`absolute rounded-full bg-[#2C1E16] ${wide ? "right-1.5 h-6 w-1.5" : "top-1.5 h-1.5 w-6"}`} />
      <UserRound size={wide ? 40 : 48} className="text-[#A83232]" aria-hidden />
      <span className={`absolute -bottom-4 -right-4 flex h-11 w-11 items-center justify-center rounded-full border-4 border-white text-white ${ok ? "bg-[#2E6930]" : "bg-[#B91C1C]"}`}>
        {ok ? <Check size={24} strokeWidth={4} /> : <X size={24} strokeWidth={4} />}
      </span>
    </div>
    <p className={`mt-2 text-xl font-bold ${ok ? "text-[#2E6930]" : "text-[#B91C1C]"}`}>{ok ? "Upright: Yes!" : "Sideways: No"}</p>
  </div>
);

export const SidewaysHelp = ({ onRetry, onClose }) => (
  <div role="alert" className="mt-6 rounded-2xl border-4 border-[#B91C1C] bg-[#FFFDF9] p-6 sm:p-8" data-testid="sideways-help">
    <h3 className="font-serif text-3xl font-bold text-[#4A2A18]">Oops! This video is sideways</h3>
    <p className="mt-3 text-lg text-[#4A3B32]">YouTube Shorts need a <b>tall</b> video. Please film again holding your phone <b>upright</b>, like when you make a phone call or read a text.</p>
    <div className="my-8 flex flex-wrap items-center justify-center gap-6 sm:gap-10" data-testid="sideways-help-graphic">
      <Phone wide />
      <RotateCw size={48} className="text-[#A83232]" aria-label="turn your phone" />
      <Phone ok />
    </div>
    <ol className="list-decimal space-y-2 pl-6 text-lg text-[#4A3B32]">
      <li>Hold your phone straight up and down, with the camera at the top.</li>
      <li>Check that the picture on the screen is <b>taller than it is wide</b>.</li>
      <li>Record your story (up to 3 minutes), then upload it here. <a href="/tips" target="_blank" rel="noreferrer" className="font-semibold text-[#A83232] underline" data-testid="sideways-tips-link">More filming tips</a></li>
    </ol>
    <div className="mt-8 flex flex-col gap-3 sm:flex-row">
      <button type="button" className="btn-primary" onClick={onRetry} data-testid="sideways-help-retry-button">Choose a different video</button>
      <button type="button" className="btn-secondary" onClick={onClose} data-testid="sideways-help-close-button">Close</button>
    </div>
  </div>
);
